<template>
  <div>
    <page-header :title="headerTitle" :subtitle="headerSubtitle" />
    <v-container class="header">
      <v-row>
        <v-col sm="12">
          Your Account
        </v-col>
      </v-row>
    </v-container>
    <v-container class="account-container">
      <v-row>
        <v-col sm="12" md="8">
          <v-card class="mx-auto text-left">
            <v-card-title>Subscription details</v-card-title>
            <v-card-subtitle>Details for your Saga Dashboard subscription</v-card-subtitle>
            <p class="mx-4 subtitle-2">Monthly cost: ${{ user.sub_plan_amount / 100 }}</p>
            <v-row>
              <v-col v-if="user.sub_plan_active" sm="12" md="6">
                <v-btn @click="manageBilling()">Manage billing</v-btn>
              </v-col>
              <v-col v-if="subCanceled" sm="12" class="text-center">
                SUBSCRIPTION CANCELED
              </v-col>
              <v-col  v-if="!user.sub_plan_active" sm="12" md="6" class="text-center">
                <div>
                  <p class="display-1 font-weight-bold paid">FREE</p>
                  <div class="caption font-weight-bold">Upgrade your account</div>
                </div>
              </v-col>
              <v-col v-else sm="12" md="6" class="text-center">
                <div v-if="user.sub_plan_active === true">
                  <p class="display-1 font-weight-bold paid">PAID</p>
                  <div class="caption font-weight-bold">Next payment due:</div>
                  <div class="caption">{{ this.timeConverter(user.sub_period_end) }}</div>
                </div>
                <div v-else>
                  <p class="overdue display-1 font-weight-bold">OVERDUE</p>
                  <div class="caption font-weight-bold">Subscription suspended on</div>
                  <div class="caption">{{ this.timeConverter(user.sub_period_end) }}</div>
                  <div class="caption font-weight-bold">Reason:</div>
                  <div class="caption">Expired Card</div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
        <v-col sm="12" md="4">
          <v-card class="mx-auto text-left">
            <v-card-title>Personal Details</v-card-title>
            <p class="mx-4">{{ user.displayName }}</p>
            <p class="mx-4">{{ user.email }}</p>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col xs="12" align="left" light>
          <p class="title">Your Account</p>
          <div v-if="userIsSame">
            <p class="caption">
              USER IS THE SAME
            </p>
          </div>
          <div v-else>
            <p class="caption">
              USER IS NOT THE SAME
            </p>
          </div>

          <table>
            <thead>
              <tr>
                <td width="300">Value</td>
                <td>Data</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Display Name</td>
                <td>{{ user.displayName }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ user.email }}</td>
              </tr>
              <tr>
                <td>Stripe ID</td>
                <td>{{ user.stripeId }}</td>
              </tr>
              <tr>
                <td>Cancel Sub at</td>
                <td>{{ user.sub_cancel_at }}</td>
              </tr>
              <tr>
                <td>Sub cancelled at</td>
                <td>{{ user.sub_canceled_at }}</td>
              </tr>
              <tr>
                <td>Sub Currency</td>
                <td>{{ user.sub_currency }}</td>
              </tr>
              <tr>
                <td>Sub ID</td>
                <td>{{ user.sub_id }}</td>
              </tr>
              <tr>
                <td>Sub Item</td>
                <td>{{ user.sub_item }}</td>
              </tr>
              <tr>
                <td>Sub Period End</td>
                <td>{{ user.sub_period_end }}</td>
              </tr>
              <tr>
                <td>Sub Period start</td>
                <td>{{ user.sub_period_start }}</td>
              </tr>
              <tr>
                <td>Sub Plan</td>
                <td>{{ user.sub_plan }}</td>
              </tr>
              <tr>
                <td>Sub Plan active</td>
                <td>{{ user.sub_plan_active }}</td>
              </tr>
              <tr>
                <td>Sub Plan Amount</td>
                <td>{{ user.sub_plan_amount }}</td>
              </tr>
              <tr>
                <td>Sub Plan Name</td>
                <td>{{ user.sub_plan_nickname }}</td>
              </tr>
              <tr>
                <td>Sub Status</td>
                <td>{{ user.sub_status }}</td>
              </tr>
            </tbody>
          </table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import firebase from '@firebase/app'
import '@firebase/auth'
import '@firebase/functions'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'Account',
  data() {
    return {
      stripeAPIToken: 'pk_test_Ex4ZqT4BRnOyJimuVax044sk00iVC52QuR',
      stripe: '',
      userIsSame: false,
      headerTitle: 'Your Account',
      headerSubtitle: 'Your Account Subtitle',
      subCanceled: false
    }
  },
  computed: {
    ...mapGetters('authentication', ['isUserLoggedIn']),
    ...mapState('authentication', ['user']),
    ...mapState('dashboard', ['dashboard']),
    ...mapState('settings', ['settings'])
  },
  beforeMount() {
    if (firebase.auth().currentUser.uid === this.user.id) {
      this.userIsSame = true
    } else {
      this.userIsSame = false
    }
  },
  mounted() {
    this.includeStripe(
      'js.stripe.com/v3/',
      // eslint-disable-next-line func-names
      function() {
        this.configureStripe()
      }.bind(this)
    )
  },
  methods: {
    includeStripe(URL, callback) {
      const documentTag = document
      const tag = 'script'
      const object = documentTag.createElement(tag)
      const scriptTag = documentTag.getElementsByTagName(tag)[0]
      object.src = `https://${URL}`
      if (callback) {
        object.addEventListener(
          'load',
          // eslint-disable-next-line func-names
          function(e) {
            callback(null, e)
          },
          false
        )
      }
      scriptTag.parentNode.insertBefore(object, scriptTag)
    },
    configureStripe() {
      // eslint-disable-next-line no-undef
      this.stripe = Stripe('sk_test_md9BXr5YQEKQsAduKW2pgzyO00rUWkZDSC')
    },
    cancelSubscription() {
      this.stripe.subscriptions.update('sub_49ty4767H20z6a', {cancel_at_period_end: true});
      this.subCanceled = true
    },
    timeConverter(timestamp) {
      const a = new Date(timestamp * 1000)
      const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      const year = a.getFullYear()
      const month = months[a.getMonth()]
      const date = a.getDate()
      const time = `${date} ${month} ${year}`
      return time
    },
    manageBilling() {
      const addMessage = firebase.functions().httpsCallable('selfServicePortal')
      addMessage(this.user.stripeId)
        .then(function(response) {
        window.location.href = response.data.url
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
    background-color: #0cbaba;
  background-image: linear-gradient(315deg, #0cbaba 0%, #380036 74%);
  }
.account-container {
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  .paid {
    color: #558B2F;
  }
  .overdue {
    color: #C62828;
  }
}
</style>